import React, { Component } from "react";
import { NavLink, Redirect } from "react-router-dom";
import firebase from "./../firebase.config";

import NotificationAlert from "react-notification-alert";

export default class Login extends Component {
  state = {
    name: "",
    email: "",
    pass: "",
    confirmPass: "",
    toSuperadminDashboard: false,
    toAdminDashboard: false,
    loading: false,
    isSignupMode: false
  };

  notificationAlert = React.createRef();
  notify(type, message) {
    var options = {};
    options = {
      place: "tr",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-touch-id",
      autoDismiss: 30
    };
    alert(message);
    // this.notificationAlert.current.notificationAlert(options);
  }

  handleChange(event, key) {
    this.setState({ [key]: event.target.value });
  }

  validateEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };
  // Ensure an /admin/{uid} record exists so the user can enter the admin
  // dashboard (Admin.jsx bounces users without this record back to /auth).
  // Once inside, the user can create their own organization on the dashboard.
  ensureAdminRecord = user => {
    return firebase
      .database()
      .ref("/admin/" + user.uid)
      .once("value")
      .then(snap => {
        if (!snap.val()) {
          return firebase
            .database()
            .ref("/admin/" + user.uid)
            .set({
              name: (this.state.name || user.displayName || "").trim(),
              email: user.email || this.state.email
            });
        }
      });
  };

  signupUser = () => {
    const { name, email, pass, confirmPass } = this.state;
    if (this.state.loading) {
      return;
    }
    if (!name || name.trim().length < 2) {
      this.notify("danger", "Please enter your name");
      return;
    }
    if (!this.validateEmail(email)) {
      this.notify("danger", "Please enter valid email address");
      return;
    }
    if (pass.length < 6) {
      this.notify("danger", "Password should be of minimum 6 characters");
      return;
    }
    if (pass !== confirmPass) {
      this.notify("danger", "Passwords do not match");
      return;
    }
    this.setState({ loading: true });

    firebase
      .auth()
      .createUserWithEmailAndPassword(email, pass)
      .then(res => {
        // Create the admin record before redirecting so the dashboard can
        // load the user and offer organization (group) creation.
        return this.ensureAdminRecord(res.user);
      })
      .then(() => {
        this.notify("success", "Account created successfully!");
        this.setState({ toAdminDashboard: true });
      })
      .catch(err => {
        this.notify("danger", err.message);
        this.setState({ loading: false });
      });
  };

  signInWithGmail = () => {
    if (this.state.loading) {
      return;
    }
    this.setState({ loading: true });

    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(res => {
        // Check if logged as admin
        firebase
          .database()
          .ref("/superadmin/" + res.user.uid)
          .once("value")
          .then(snap => {
            if (snap.val()) {
              this.setState({ toSuperadminDashboard: true });
            } else {
              // Create the admin record if this is a first-time sign in,
              // then let the user set up their organization on the dashboard.
              this.ensureAdminRecord(res.user).then(() => {
                this.setState({ toAdminDashboard: true });
              });
            }
          })
          .catch(err => {
            console.warn(err.message);
            firebase.auth().signOut();
            this.setState({ loading: false });
            this.notify(
              "danger",
              "There was an error signing in, please try again later."
            );
          });
      })
      .catch(err => {
        this.notify("danger", err.message);
        this.setState({ loading: false });
      });
  };

  loginUser = () => {
    const { email, pass } = this.state;
    if (this.state.loading) {
      return;
    }
    if (!this.validateEmail(email)) {
      this.notify("danger", "Please enter valid email address");
      return;
    }
    if (pass.length < 6) {
      this.notify("danger", "Password should be of minimum 6 characters");
      return;
    }
    this.setState({ loading: true });

    firebase
      .auth()
      .signInWithEmailAndPassword(email, pass)
      .then(res => {
        //check if logged as admin
        firebase
          .database()
          .ref("/superadmin/" + res.user.uid)
          .once("value")
          .then(snap => {
            if (snap.val()) {
              // this.notify("success", "Authentication Successful");
              this.setState({ toSuperadminDashboard: true });
            } else {
              // Ensure the /admin/{uid} record exists before redirecting.
              // Without it, Admin.jsx bounces the user straight back to /auth,
              // which looks like a failed login (e.g. accounts created in the
              // Firebase console or before this record logic existed).
              this.ensureAdminRecord(res.user).then(() => {
                this.setState({ toAdminDashboard: true });
              });

              // firebase.auth().signOut();
              // this.notify(
              //   "danger",
              //   "You don't have enough previleges to login to dashboard"
              // );
              // this.setState({ loading: false });
            }
          })
          .catch(err => {
            console.warn(err.message);
            firebase.auth().signOut();
            this.setState({ loading: false });

            this.notify(
              "danger",
              "There was an error signing in, please try again later."
            );
          });
      })
      .catch(err => {
        this.notify("danger", err.message);
        this.setState({ loading: false });
      });
  };

  render() {
    if (this.state.toSuperadminDashboard === true) {
      return <Redirect to="/superadmin/admins" />;
    }
    else if (this.state.toAdminDashboard === true) {
      return <Redirect to="/admin/dashboard" />;
    }
    return (
      <div
        style={{
          width: "100%",
          paddingLeft: "7%",
          paddingRight: "7%",
          marginTop: 30
        }}
      >
        <NotificationAlert ref={this.notificationAlert} />

        <h3 style={styles.title}>
          {this.state.isSignupMode ? "Create Account" : "Please Login to continue"}
        </h3>
        
        {this.state.isSignupMode && (
          <input
            style={styles.input}
            placeholder="Name"
            value={this.state.name}
            onChange={evt => {
              this.handleChange(evt, "name");
            }}
          />
        )}

        <input
          style={styles.input}
          placeholder="Email Address"
          value={this.state.email}
          onChange={evt => {
            this.handleChange(evt, "email");
          }}
        />

        <input
          style={styles.input}
          placeholder="Password"
          type="password"
          value={this.state.pass}
          onChange={evt => {
            this.handleChange(evt, "pass");
          }}
        />

        {this.state.isSignupMode && (
          <input
            style={styles.input}
            placeholder="Confirm Password"
            type="password"
            value={this.state.confirmPass}
            onChange={evt => {
              this.handleChange(evt, "confirmPass");
            }}
          />
        )}

        {this.state.loading ? (
          <button style={styles.button} onClick={() => { }}>
            Loading...
          </button>
        ) : (
          <button
            style={styles.button}
            onClick={() => {
              this.state.isSignupMode ? this.signupUser() : this.loginUser();
            }}
          >
            {this.state.isSignupMode ? "Sign Up" : "Log in"}
          </button>
        )}

        <button
          style={styles.gmailButton}
          onClick={() => {
            this.signInWithGmail();
          }}
          disabled={this.state.loading}
        >
          {this.state.isSignupMode ? "Sign up with Gmail" : "Sign in with Gmail"}
        </button>

        <button
          style={styles.toggleButton}
          onClick={() => {
            this.setState({
              isSignupMode: !this.state.isSignupMode,
              name: "",
              email: "",
              pass: "",
              confirmPass: ""
            });
          }}
        >
          {this.state.isSignupMode 
            ? "Already have an account? Log in" 
            : "Don't have an account? Sign up"}
        </button>

        {!this.state.isSignupMode && (
          <NavLink
            to={"/auth/recover"}
            className="nav-link"
            style={styles.buttonPass}
          >
            Forgot your password?
          </NavLink>
        )}
      </div>
    );
  }
}

const styles = {
  title: {
    width: "100%",
    textAlign: "center",
    fontWeight: "600"
  },
  input: {
    width: "100%",
    marginTop: 30,
    borderRadius: 5,
    borderColor: "rgb(190,190,190)",
    borderWidth: 1,
    borderStyle: "solid",
    padding: 20
  },
  button: {
    marginTop: 20,
    width: "100%",
    padding: 12,
    backgroundColor: "rgb(88,141,240)",
    border: 0,
    borderRadius: 5,
    color: "white",
    fontWeight: "600",
    cursor: "pointer"
  },
  gmailButton: {
    marginTop: 10,
    width: "100%",
    padding: 12,
    backgroundColor: "rgb(219,68,55)",
    border: 0,
    borderRadius: 5,
    color: "white",
    fontWeight: "600",
    cursor: "pointer"
  },
  toggleButton: {
    marginTop: 15,
    backgroundColor: "transparent",
    borderWidth: 0,
    width: "100%",
    textAlign: "center",
    cursor: "pointer",
    fontWeight: "600",
    color: "rgb(88,141,240)",
    fontSize: "14px"
  },
  buttonPass: {
    marginTop: 5,
    backgroundColor: "transparent",
    borderWidth: 0,
    width: "100%",
    textAlign: "center",
    cursor: "pointer",
    cursor: "hand",
    fontWeight: "600",
    color: "black"
  },
  buttonSignup: {
    marginTop: 30,
    backgroundColor: "transparent",
    borderWidth: 0,
    width: "100%",
    textAlign: "center",
    color: "black"
  }
};
